<div class="row left-margin right-margin">
	<div class="col-md-12">
		@if (gettingTestRuns | async) {
			<div class="col-md-12 loader"></div>
		}
		@if (testCases?.length > 0) {
			<div class="col-md-10">
				<h2>Results for test case: {{ this.testCases[0].testRun.testResults[0].testCaseItemNo }} - {{ this.testCases[0].testRun.testResults[0].testCaseName }}&nbsp;</h2>
			</div>
			<div class="col-md-2 align-right no-padding">
				<div class="col-md-12 no-padding">
					<input type="text" id="txtSearchTestCase" class="form-control" placeholder="Filter..." (keyup)="applyFilter($event)" />
				</div>
			</div>
			<div class="col-md-12 mat-elevation-z0">
				<table mat-table [dataSource]="dataSource" matSort>
					<ng-container matColumnDef="itemNo">
						<th mat-header-cell *matHeaderCellDef mat-sort-header>ItemNo</th>
						<td mat-cell *matCellDef="let element">
							<span *ngIf="element.testRunType === 410; else elseBlockItemNo">
								{{ element.testSpecification.itemNo }}
							</span>
							<ng-template #elseBlockItemNo>
								{{ element.testSuite.itemNo }}
							</ng-template>
						</td>
					</ng-container>
					<ng-container matColumnDef="name">
						<th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
						<td mat-cell *matCellDef="let element">
							<span *ngIf="element.testRunType === 410; else elseBlockName">
								{{ element.testSpecification.name }}
							</span>
							<ng-template #elseBlockName>
								{{ element.testSuite.name }}
							</ng-template>
						</td>
					</ng-container>
					<ng-container matColumnDef="type">
						<th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
						<td mat-cell *matCellDef="let element">
							<span *ngIf="element.testRunType === 410; else elseBlockType">Test specification</span>
							<ng-template #elseBlockType>Test suite</ng-template>
						</td>
					</ng-container>
					<ng-container matColumnDef="environment">
						<th mat-header-cell *matHeaderCellDef mat-sort-header width="10%">Environment</th>
						<td mat-cell *matCellDef="let element">{{ element.testRun.environment }}</td>
					</ng-container>
					<ng-container matColumnDef="testCaseVersion">
						<th mat-header-cell *matHeaderCellDef mat-sort-header width="10%">Test case version</th>
						<td mat-cell *matCellDef="let element">{{ element.testRun.testResults[0].testCaseVersion }}</td>
					</ng-container>
					<ng-container matColumnDef="result">
						<th mat-header-cell *matHeaderCellDef mat-sort-header width="10%">Result</th>
						<td mat-cell *matCellDef="let element">{{ element.testRun.testResults[0].result }}</td>
					</ng-container>
					<ng-container matColumnDef="troubleReports">
						<th mat-header-cell *matHeaderCellDef mat-sort-header>Trouble reports</th>
						<td mat-cell *matCellDef="let element">
							<i *ngIf="element.testRun.testResults[0].troubleReports.length > 0" class="scania-icon-trouble-report xs" title="Trouble reports exist"></i>
						</td>
					</ng-container>
					<ng-container matColumnDef="resultComment">
						<th mat-header-cell *matHeaderCellDef mat-sort-header width="20%">Result comment</th>
						<td mat-cell *matCellDef="let element">
							{{ element.testRun.testResults[0].resultComment }}
							<div
								*ngIf="
									(element.testRun.testResults[0].positiveComment !== '' && element.testRun.testResults[0].positiveComment !== null) ||
									(element.testRun.testResults[0].negativeComment !== '' && element.testRun.testResults[0].negativeComment !== null)
								"
							>
								<table class="table-condensed no-margin">
									<tbody>
										<tr *ngIf="element.testRun.testResults[0].positiveComment !== '' && element.testRun.testResults[0].positiveComment !== null">
											<td class="no-padding" title="Positive comment">
												<span class="glyphicon glyphicon-ok-sign text-success"></span>
												{{ element.testRun.testResults[0].positiveComment }}
											</td>
										</tr>
										<tr *ngIf="element.testRun.testResults[0].negativeComment !== '' && element.testRun.testResults[0].negativeComment !== null">
											<td class="no-padding" title="Negative comment">
												<span class="glyphicon glyphicon-remove-sign text-danger"></span>
												{{ element.testRun.testResults[0].negativeComment }}
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</td>
					</ng-container>
					<ng-container matColumnDef="executionTime">
						<th mat-header-cell *matHeaderCellDef mat-sort-header>Execution time</th>
						<td mat-cell *matCellDef="let element">{{ element.testRun.executionTime | date: 'yyyy-MM-dd HH:mm:ss' }}</td>
					</ng-container>
					<ng-container matColumnDef="regBy">
						<th mat-header-cell *matHeaderCellDef mat-sort-header>Executed by</th>
						<td mat-cell *matCellDef="let element">{{ element.testRun.regBy }}</td>
					</ng-container>
					<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
					<tr
						mat-row
						*matRowDef="let row; columns: displayedColumns"
						[ngClass]="{ failed: row.testRun.testResults[0].result === 'failed', passed: row.testRun.testResults[0].result === 'passed', hovered: row.hovered }"
						(focus)="row.hovered = true"
						(mouseover)="row.hovered = true"
						(blur)="row.hovered = false"
						(mouseout)="row.hovered = false"
						(click)="navigateTo(row)"
					></tr>
				</table>
				<mat-paginator [pageSizeOptions]="getPageSizeOptions()" showFirstLastButtons></mat-paginator>
			</div>
		} @else if (testCases?.length === 0) {
			<span class="scania-icon-info xs"></span>
			<span class="bold">There are no results for this test case or you are not authorized to view them</span>
		}
	</div>
</div>
